import React, { Component } from 'react'
import CadastroNews from '../layout/CadastroNews';
import CardsDestino from '../layout/DestinosMaisVendidos/CardsDestinos';
import CardsGuiasDicas from '../layout/CardsGuiaDicas';
import Carousel from './Carousel';
import CarouselAgencia from './CarouselAgencia';
import { recuperarConfEmpresa } from '../../util/applicationContext';
import { limparPassagens} from '../../actions/vendasActions';
import BotaoVoltarAoTopo from '../layout/BotaoVoltarAoTopo';
import CarouselCards from '../layout/CarouselCards';
import CardQueroUmaAgencia from '../layout/CardQueroUmaAgencia';
import CardsTopTrechos from '../layout/CardsTopTrechos';
import CardsEmpresas from '../layout/CardsEmpresas';
import CardsTopRedePesquisa from '../layout/CardsTopRedePesquisa';
import {connect} from 'react-redux';
import CarouselExpressoJK from './CarouselExpressoJK';
import CardsDestinosExpressojk from '../layout/DestinosMaisVendidos/CardsDestinosExpressojk';
import CarouselTurissulPassagens from './CarouselTurissulPassagens';
import CardsLocaisEmbarquePorCidade from '../layout/CardsLocaisEmbarquePorCidade';

export class PaginaInicial extends Component {
    componentDidMount() {
        this.props.limparPassagens();
    }

  retornaCardsTopTrechos() {
    if (recuperarConfEmpresa().pastaEstilo === 'politurtransfer') {
      return ''
    }

    return <CardsTopTrechos />
  }

  retornaCardsCidadeLocalEmbarque() {
    if (recuperarConfEmpresa().pastaEstilo === 'turissulpassagens') {
      return <CardsLocaisEmbarquePorCidade />
    }

    return ''
  }

  returnaCardsEmpresas() {
    if (recuperarConfEmpresa().pastaEstilo === 'politurtransfer') {
      return <CardsTopTrechos />
    }

    return (
      recuperarConfEmpresa().pastaEstilo === 'amarelinho' ||
      recuperarConfEmpresa().pastaEstilo === 'basilioebasilio' ||         
      recuperarConfEmpresa().pastaEstilo === 'transbrasilpassagens' ||
      recuperarConfEmpresa().pastaEstilo === 'politurtransfer' ||
      recuperarConfEmpresa().pastaEstilo === 'turissulpassagens' ||
      recuperarConfEmpresa().pastaEstilo === 'vipbrasil' ||
      recuperarConfEmpresa().pastaEstilo === 'samaturpassagens' ||
      recuperarConfEmpresa().pastaEstilo === 'siqueiratur' ||
      recuperarConfEmpresa().pastaEstilo === 'expressojk'
        ? '' : <CardsEmpresas />
    )
  }

  retornaCardDestinos() {
    if (recuperarConfEmpresa().pastaEstilo === 'politurtransfer' ||
    recuperarConfEmpresa().pastaEstilo === 'turissulpassagens' ||
    recuperarConfEmpresa().pastaEstilo === 'samaturpassagens' ||
    recuperarConfEmpresa().pastaEstilo === 'siqueiratur') {
      return ''
    }

    if (recuperarConfEmpresa().pastaEstilo === 'expressojk') {
      return <CardsDestinosExpressojk />
    }

    return <CardsDestino />
  }

  exibirCarousel() {
    if (recuperarConfEmpresa().pastaEstilo === 'agencia' ||
          recuperarConfEmpresa().pastaEstilo === 'pegabus' ||
          recuperarConfEmpresa().pastaEstilo === 'basilioebasilio' ||
          recuperarConfEmpresa().pastaEstilo === 'transbrasilpassagens') {
        return <CarouselAgencia />
    } else if (recuperarConfEmpresa().pastaEstilo === 'expressojk') {
        return <CarouselExpressoJK />
    } else if (recuperarConfEmpresa().pastaEstilo === 'turissulpassagens') {      
      return <CarouselTurissulPassagens />
    } else {
        return <Carousel />
    }
  }

  render() {
    return (
      <div>
        {this.exibirCarousel()}
        {recuperarConfEmpresa().pastaEstilo === 'politurtransfer' ||
          recuperarConfEmpresa().pastaEstilo === 'turissulpassagens' ||
          recuperarConfEmpresa().pastaEstilo === 'expressojk' ? 
          '' : <CadastroNews />}
        {this.returnaCardsEmpresas()}        
        {this.retornaCardDestinos()}        
        {recuperarConfEmpresa().pastaEstilo === 'agencia' ||
          recuperarConfEmpresa().pastaEstilo === 'vexado' ||
          recuperarConfEmpresa().pastaEstilo === 'expressoadamantinanovo' ||
          recuperarConfEmpresa().pastaEstilo === 'brasilpassagens' ?
        <CardsTopRedePesquisa /> : ''}
        {this.retornaCardsTopTrechos()}
        {/* {this.retornaCardsCidadeLocalEmbarque()}// comentado temporariamente a pedido do cliente Turissul */}
        {recuperarConfEmpresa().pastaEstilo === 'turissulpassagens'  ||
          recuperarConfEmpresa().pastaEstilo === 'expressojk'  
          ? '' : <CarouselCards />}
        
        {recuperarConfEmpresa().pastaEstilo === 'turissulpassagens' || 
          recuperarConfEmpresa().pastaEstilo === 'siqueiratur' ||
          recuperarConfEmpresa().pastaEstilo === 'expressojk'
          ? '' 
          : <CardsGuiasDicas site={recuperarConfEmpresa().pastaEstilo} />}

        {recuperarConfEmpresa().pastaEstilo === 'turissulpassagens' ||
          recuperarConfEmpresa().pastaEstilo === 'siqueiratur' ? '' 
          : <CardQueroUmaAgencia /> }
        {recuperarConfEmpresa().pastaEstilo === 'turissulpassagens' ? '' : <BotaoVoltarAoTopo />}
      </div>
    )
  }
}

export default connect(null, {limparPassagens})(PaginaInicial)
